import { useMutation } from 'react-query';

import { updateTag as mutationFn } from 'api/endPoints/updateTag';

export const useMutationUpdateTag = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    customerId: number;
    oldName: string;
    newName: string;
    projectId: number;
}
